import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const styles = tv({
	slots: {
		base: 'w-full flex flex-col md:grid md:grid-cols-6 gap-x-2 md:gap-x-4 px-2 lg:px-4',
	},
})

export type StylesVariants = VariantProps<typeof styles>
